module.exports = __webpack_public_path__ + "ad5c5166512f5653976c36ea86a74162.svg";